import React, { Fragment, useEffect, useState, useRef } from 'react'
import { Row, Col, Card, Table, Badge, Dropdown, DropdownButton, ProgressBar } from 'react-bootstrap'
import { useHistory, useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom'
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes"
import Pagination from '@mui/material/Pagination'
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import * as constants from '../../../utils/Constants'

const TopRecruitingAgents = () => {
    const [page, setPage] = React.useState(1);
    const [pageDetails, setPageDetails] = useState({})
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [items, setItems] = useState({});
    const history = useHistory();
    const [searchText, setSearchText] = useState('')
    const loggedInUser = JSON.parse(localStorage.getItem('user'))
    let agentData = []

    function getAllRecruitingAgents(page, search, sort) {
        fetch(`${constants.ListRecruitingAgentsUrl}?page=${page}&search=${search || ''}&sortBy=${sort || ''}&top5Agents=1`,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${loggedInUser.sessionToken}`,
                },
            })
            .then(res => res.json())
            .then(
                (result) => {
                    setIsLoaded(true);
                    setItems(result?.data?.content);
                    setPageDetails(result?.data)
                },
                (error) => {
                    setIsLoaded(true);
                    setError(error);
                }
            )
    }

    const handlePageChange = (event, value) => {
        setPage(value);
        getAllRecruitingAgents(value - 1, searchText)
    }

    useEffect(() => {
        window.scrollTo(0, 0)
        getAllRecruitingAgents(0)
    }, [])

    useEffect(() => {
        handleSearch(searchText);
    }, [searchText])

    if (items?.length > 0) {
        agentData = [...(items)];
    }

    const handleRowClick = (selectedRow) => {
      history.push({
            pathname: '/agent-profile',
            state: selectedRow
        })
    }

    const handleApproval = (selectedRow) => {
        fetch(`${constants.ApproveOrRejectAgentUrl}/${selectedRow.agentId}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${loggedInUser.sessionToken}`,
            },
            body: JSON.stringify({ "agentStatus": "Approved" })
        })
            .then(response => response.json())
            .then((res) => {
                if (res?.message) {
                    fetch(constants.ListRecruitingAgentsUrl, {
                        method: 'POST',
                        headers: {
                            'Authorization': `Bearer ${loggedInUser.sessionToken}`,
                        }
                    })
                        .then(res => res.json())
                        .then(
                            (result) => {
                                // console.log(result)
                                setIsLoaded(true);
                                setItems(result.data);
                            },
                            (error) => {
                                setIsLoaded(true);
                                setError(error);
                            }
                        )
                }
            })

    }

    const handleRejection = (selectedRow) => {
        fetch(`${constants.ApproveOrRejectAgentUrl}/${selectedRow.agentId}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${loggedInUser.sessionToken}`,
            },
            body: JSON.stringify({ "agentStatus": "Rejected" })
        })
            .then(response => response.json())
            .then((res) => {
                if (res?.message) {
                    fetch(constants.ListRecruitingAgentsUrl, {
                        method: 'POST',
                        headers: {
                            'Authorization': `Bearer ${loggedInUser.sessionToken}`,
                        }
                    })
                        .then(res => res.json())
                        .then(
                            (result) => {
                                // console.log(result)
                                setIsLoaded(true);
                                setItems(result.data);
                            },
                            (error) => {
                                setIsLoaded(true);
                                setError(error);
                            }
                        )
                }
            })
    }

    const handleSearch = () => {
        setPage(1)
        getAllRecruitingAgents(0, searchText)
    }

    return (
        <Fragment>
            <div className='d-flex flex-wrap mb-4'>
                <div className='mr-auto mb-2 pr-2 show-results'>
                    <h6 className='text-black fs-16 font-w600 mb-1'>
                        Showing {pageDetails?.totalElements} Recruiting Agents Results
                    </h6>
                    <span className='fs-14'>Based your preferences</span>
                </div>
            </div>
            <div className='row'>
                <div className='col-xl-12'>
                    <div className='table-responsive'>
                        <div id='application' className='dataTables_wrapper no-footer'>
                            {!isLoaded
                                ?
                                <div>
                                    <Box className='card' sx={{ width: '100%' }}>
                                        <LinearProgress />
                                    </Box>
                                </div>
                                : !items || agentData?.length <= 0 ? <div>No records found</div>
                                    :
                                    <table
                                        className='table display mb-4 dataTablesCard table-responsive-xl card-table dataTable no-footer'
                                        id='example5'
                                    >
                                        <thead>
                                            <tr role='row'>
                                                <th className='sorting'>Name</th>
                                                <th className='sorting'>Agent Code</th>
                                                <th className='sorting'>Email Id</th>
                                                <th className='sorting'>Mobile Number</th>
                                                <th className='sorting'>Status</th>
                                                <th className='sorting'>Aadhar Number</th>
                                                <th className='sorting'>PAN</th>
                                                <th className='sorting'>Agreement</th>
                                                <th className='sorting'>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {agentData?.map((candidate) =>
                                            (
                                                <tr role='row'
                                                    style={{
                                                        cursor: 'pointer',
                                                    }}
                                                    className='odd' >
                                                    <td onClick={() => handleRowClick(candidate)}>{candidate.agentName}</td>
                                                    <td onClick={() => handleRowClick(candidate)}>{candidate.agentCode}</td>
                                                    <td onClick={() => handleRowClick(candidate)}>{candidate.emailId}</td>
                                                    <td onClick={() => handleRowClick(candidate)}>{candidate.mobileNumber}</td>
                                                    <td onClick={() => handleRowClick(candidate)}>
                                                        <div>
                                                            <button style={{
                                                                border: 'none',
                                                                backgroundColor: candidate.agentStatus === 'Unverified' ? 'Blue' : candidate.agentStatus === 'Accepted' ? 'Green' : candidate.agentStatus === 'Approved' ? '#FFCA2C' : 'Red',
                                                                textAlign: 'center'
                                                            }}
                                                                type="button"
                                                                className="btn btn-primary btn-md"
                                                            >
                                                                {candidate?.agentStatus}
                                                            </button>
                                                        </div>
                                                    </td>
                                                    <td onClick={() => handleRowClick(candidate)}>{candidate.aadharCard}</td>
                                                    <td onClick={() => handleRowClick(candidate)}>{candidate.panCard}</td>
                                                    <td onClick={() => handleRowClick(candidate)}>{candidate.agreementStatus}</td>
                                                    <td>
                                                        <div className='d-flex align-items-center'>
                                                            <Dropdown className='dropdown float-right custom-dropdown mb-0'>
                                                                <Dropdown.Toggle
                                                                    className='i-false'
                                                                    data-toggle='dropdown'
                                                                    variant=''
                                                                >
                                                                    <svg
                                                                        width={24}
                                                                        height={24}
                                                                        viewBox='0 0 24 24'
                                                                        fill='none'
                                                                        xmlns='http://www.w3.org/2000/svg'
                                                                    >
                                                                        <path
                                                                            d='M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z'
                                                                            stroke='#2E2E2E'
                                                                            strokeWidth={2}
                                                                            strokeLinecap='round'
                                                                            strokeLinejoin='round'
                                                                        />
                                                                        <path
                                                                            d='M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z'
                                                                            stroke='#2E2E2E'
                                                                            strokeWidth={2}
                                                                            strokeLinecap='round'
                                                                            strokeLinejoin='round'
                                                                        />
                                                                        <path
                                                                            d='M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z'
                                                                            stroke='#2E2E2E'
                                                                            strokeWidth={2}
                                                                            strokeLinecap='round'
                                                                            strokeLinejoin='round'
                                                                        />
                                                                    </svg>
                                                                </Dropdown.Toggle>

                                                                <Dropdown.Menu className='dropdown-menu dropdown-menu-right'>
                                                                    {candidate.agentStatus === 'Unverified' &&
                                                                        <Dropdown.Item className='dropdown-item' onClick={() => handleApproval(candidate)}>
                                                                            Approve
                                                                        </Dropdown.Item>}
                                                                    {candidate.agentStatus === 'Unverified' &&
                                                                        <Dropdown.Item className='dropdown-item' onClick={() => handleRejection(candidate)}>
                                                                            Reject
                                                                        </Dropdown.Item>
                                                                    }
                                                                    <Dropdown.Item className='dropdown-item text-danger'>
                                                                        Cancel
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                            )}
                                        </tbody>
                                    </table>
                            }
                            <div className='d-sm-flex text-center justify-content-between align-items-center'>
                                <div className='dataTables_info' id='example5_info'>
                                    Page: {page}
                                </div>
                                <div>
                                    <Pagination count={pageDetails?.totalPages} page={page} onChange={handlePageChange} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </Fragment >
    )
}

export default TopRecruitingAgents